export enum GIFT_CARD_PROVIDERS {
  VALUTEC = 'valutec',
  SQUARE = 'square',
}

/** Id of a gift-card form's inline error alert, referenced by its inputs' `aria-describedby`. */
export const GIFT_CARD_ERROR_MESSAGE_ID = 'gift-card-error-message';

/** Id of the gift-card window message in the section header (TEAM-15105). */
export const GIFT_CARD_WINDOW_MESSAGE_ID = 'gift-card-window-message';

/**
 * The zone the gift-card window's days are counted in: chowly-api's `config.time_zone`
 * ('Central Time (US & Canada)'), which `ValutecGiftCardPayment.within_scheduling_window?` reads.
 * Not the store's zone. (TEAM-15105)
 */
export const GIFT_CARD_WINDOW_TIME_ZONE = 'America/Chicago';
